import router from './router';
import axios from 'axios';
import _ from 'lodash';

axios.defaults.headers.get['Pragma'] = 'no-cache';
axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store';

const api = axios.create({ baseURL: '/api' });
api.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        if (_.includes([401, 403], error.response.status)) {
            setTimeout(() => {
                if (router.history.current.path !== '/login') {
                    router.push('/login');
                }
            });
        }
        return Promise.reject(error);
    }
);

export default api;
